import React from "react";
import { Helmet } from "react-helmet-async";
import SignupForm from "@/components/auth/SignupForm";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Signup: React.FC = () => {
  const navigate = useNavigate();

  const handleSignup = async (formData) => {
    // ... existing registration logic ...
    // After successful registration:
    navigate('/verify-email');
  };

  return (
    <>
      <Helmet>
        <title>Signup | SaunaDip</title>
        <meta name="description" content="Join SaunaDip as a sauna or plunge operator" />
      </Helmet>
      
      <div className="bg-sauna-beige min-h-screen flex items-start justify-center px-2 mt-4">
        <SignupForm />
      </div>
    </>
  );
};

export default Signup;
